import React from 'react'
import { createUseStyles } from 'react-jss'
import obj2Arr from '../../utils/obj2Arr'

const useStyles = createUseStyles(theme => ({
  accCntainer: {
    padding: '45px 0',
    margin: '0 auto',
    width: '100%',
    maxWidth: '1200px',
    '@media (max-width: 700px)': {
      padding: '25px 0',
    },
    '& > div': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridGap: '100px',
      '@media (max-width: 1200px)': {
        boxSizing: 'border-box',
        padding: '25px 15px',
      },
      '@media (max-width: 700px)': {
        gridTemplateColumns: '1fr',
        gridGap: '0',
        boxSizing: 'border-box',
        padding: '25px 15px',
      },
    },
  },
  accTitle: {
    fontSize: '26px',
    lineHeight: '32px',
    letterSpacing: '-1%',
    marginBottom: '30px',
    marginTop: '10px',
    fontWeight: 700,
  },
  accDetails: {
    '& p': {
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.02em',
    },
  },
  linkss: {
    display: 'block',
    color: theme.colors.blue,
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: '20px',
    textAlign: 'left',
    backgroundColor: theme.colors.white,
    cursor: 'pointer',
    padding: '22px 70px 22px 39px',
    alignItems: 'center',
    border: 'none',
    outline: 'none',
    transition: `background-color 250ms ${theme.animations.bezier}`,
    borderBottom: '1px solid #D8D8D8',
    textDecoration: 'none',
    background: '#fff url("/themes/thrifty/assets/images/golink.png") 98% center no-repeat',
    '&:hover': {
      textDecoration: 'underline',
    },
    '@media (max-width: 700px)': {
      fontSize: 15,
      padding: '10px 40px 10px 0',
      backgroundSize: '15px 15px',
    },
  },
  linkbox: {
    borderRadius: 30,
    backgroundColor: '#fff',
    padding: '20px',
    '@media (max-width: 700px)': {
      marginTop: 20,
      padding: '15px',
    },
    '& a:last-child': {
      borderBottom: 'none',
    },
  },
}))

const LinkBox = props => {
  const classes = useStyles()
  const { title, body, links } = props
  const objArr = obj2Arr(links)
  return (
    <div style={{ backgroundColor: '#F0F8FF' }}>
      <div className={classes.accCntainer}>
        <div>
          <div>
            <div className={classes.accTitle}>{title}</div>
            <div className={classes.accDetails} dangerouslySetInnerHTML={{ __html: body }} />
          </div>
          <div>
            <div className={classes.linkbox}>
              {objArr &&
                objArr.map(({ title, url }) => (
                  <a
                    key={title}
                    className={classes.linkss}
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {title}
                  </a>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LinkBox
